import { render, staticRenderFns } from "./paymentReceivedDataTable.vue?vue&type=template&id=1f0d6a4e&"
import script from "./paymentReceivedDataTable.vue?vue&type=script&lang=js&"
export * from "./paymentReceivedDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports